module.exports = __webpack_public_path__ + "img/glitter_5.1ae84ed1.jpg";